<template>
    <div>
 
      <div>
        <h2>Make Calls</h2>
        <ul>
          <li v-for="call in makeCalls" :key="call.id">
            <p><strong>User:</strong> {{ call.user }}</p>
            <h1><strong>Name:</strong> {{ call.name }}</h1>
            <p><strong>Status:</strong> {{ call.status }}</p>
            <h3><strong>Interaction:</strong> {{ call.interaction }}</h3>
            <p><strong>Last Call:</strong> {{ call.lastCall }}</p>
            <p><strong>Next Call:</strong> {{ call.nextCall }}</p>
            <p><strong>Phone Number:</strong> {{ call.phoneNumber }}</p>
            <p><strong>No:</strong> {{ call.no }}</p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Contacts</h2>
        <ul>
          <li v-for="contact in contacts" :key="contact.id">
            <p><strong>ID:</strong> {{ contact.id }}</p>
            <p><strong>Name:</strong> {{ contact.name }}</p>
            <p><strong>Email:</strong> {{ contact.email }}</p>
            <!-- Add other contact fields here as needed -->
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import { io } from 'socket.io-client';
  import { ref, onMounted, onUnmounted } from 'vue';
  
  export default {
    name: 'SocketComponent',
    setup() {
      const SERVER_URL = process.env.VUE_APP_SERVER_URL || 'https://sp412b-763ef468411d.herokuapp.com/' || 'http://localhost:1337' ; // Use environment variable
      const socket = io(SERVER_URL);
      
      const makeCalls = ref([]);
      const contacts = ref([]);
  
      const onConnect = () => {
        console.log('Socket connected!');
  
        socket.on('makeCall:create', (data) => {
          console.log('makeCall created!', data);
          makeCalls.value.push(data);
        });
  
        socket.on('makeCall:update', (data) => {
          console.log('makeCall updated!', data);
          const index = makeCalls.value.findIndex(call => call.id === data.id);
          if (index !== -1) {
            makeCalls.value[index] = { ...makeCalls.value[index], ...data };
          } else {
            makeCalls.value.push(data);
          }
        });
  
        socket.on('makeCall:delete', (data) => {
          console.log('makeCall deleted!', data);
          makeCalls.value = makeCalls.value.filter(call => call.id !== data.id);
        });
  
        socket.on('contact:create', (data) => {
          console.log('contact created!', data);
          contacts.value.push(data);
        });
  
        socket.on('contact:update', (data) => {
          console.log('contact updated!', data);
          const index = contacts.value.findIndex(contact => contact.id === data.id);
          if (index !== -1) {
            contacts.value[index] = { ...contacts.value[index], ...data };
          } else {
            contacts.value.push(data);
          }
        });
  
        socket.on('contact:delete', (data) => {
          console.log('contact deleted!', data);
          contacts.value = contacts.value.filter(contact => contact.id !== data.id);
        });
      };
  
      const onDisconnect = () => {
        console.log('Socket disconnected!');
      };
  
      onMounted(() => {
        console.log('start!');
        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);
      });
  
      onUnmounted(() => {
        socket.off('connect', onConnect);
        socket.off('disconnect', onDisconnect);
        socket.disconnect();
      });
  
      return {
        makeCalls,
        contacts,
      };
    }
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>
  